export const SHARE_USER = "SHARE_USER";
export const ADD_PROJECT = "ADD_PROJECT";
export const ADD_TRANSACTION = "ADD_TRANSACTION";
export const ADD_IMAGE_TO_TRANSACTION = "ADD_IMAGE_TO_TRANSACTION";
export const ADD_PETTY_CASH = "ADD_PETTY_CASH";
export const GET_PDF = "GET_PDF";
export const GET_EXCEL = "GET_EXCEL";
export const GET_ACCOUNTANT = "GET_ACCOUNTANT";
export const HASHTAG_REPORT = "HASHTAG_REPORT";
export const MONTHLY_REPORT = "MONTHLY_REPORT";
export const CONTACT_REPORT = "CONTACT_REPORT";
export const ADD_MONTHLY_BUDGET = "ADD_MONTHLY_BUDGET";
export const ADD_PETTY_CASH_BUDGET = "ADD_PETTY_CASH_BUDGET";
export const PRINT_SUMMARY_PAYMENT_RECEIVE = "PRINT_SUMMARY_PAYMENT_RECEIVE";
export const COPY_TRANSACTION = "COPY_TRANSACTION";
export const DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION";
export const ADMIN_ADD_TRANSACTION = "ADMIN_ADD_TRANSACTION";
export const ADD_OR_EDIT_TEAM = "ADD_OR_EDIT_TEAM";
export const ADD_OR_MANAGE_TEAM_LEVEL = "ADD_OR_MANAGE_TEAM_LEVEL";
export const DEFINE_ADMIN_OR_MANAGER = "DEFINE_ADMIN_OR_MANAGER";
export const IMPORT_ACCOUNT_TITLE = "IMPORT_ACCOUNT_TITLE";
export const IMPORT_TRANSACTIONS = "IMPORT_TRANSACTIONS";
export const ACCOUNT_TITLE_LEVEL = "ACCOUNT_TITLE_LEVEL";
export const CONNECT_WITH_API = "CONNECT_WITH_API";
export const CONNECT_TO_PARTNERS = "CONNECT_TO_PARTNERS";
export const TRANSACTION_DATE = "TRANSACTION_DATE";
export const IMPREST_PAYMENT = "IMPREST_PAYMENT";
